
import { computed, onBeforeUnmount, onMounted, useAsync, useContext, useRoute, watch } from '@nuxtjs/composition-api'
import useTlmCart from '@/composable/useTlmCart';
import useEnvironment from '~/composable/various/useEnvironment';
import useCategories from '@/composable/useCategories';
import useCartScenarios from '~/composable/useCartScenarios';

export default {
  name: 'PageCheckout',
  setup() {
    const { app } = useContext()
    const { isCartEmpty, loadOrCreateCart, isLoading, getCategoryForCartItemGroup, cart } = useTlmCart(app);
    const { setScenario } = useCartScenarios(app)
    const { getCategories, getOfferedToCustomerTypeInfo, getHasSpecialPrices } = useCategories(app.$hubble)

    const route = useRoute()
    const cartId = route.value.query.cartId
    const cameFromMitid = computed(() => !!route.value.query.code || !!route.value.query.error)
    let categoryId

    watch(isLoading, () => {
      // Don't redirect if coming from MitID (has code query param) - let MitID flow complete
      if (!isLoading.value && isCartEmpty.value && !cameFromMitid.value) {
        location.href = location.origin + '/shop'
      }
    })

    useAsync(async () => {
      try {
        await loadOrCreateCart(cartId)
        await getCategories()
        categoryId = getCategoryForCartItemGroup() || route.value.query.categoryId
        // Only call category info functions if categoryId exists
        if (categoryId) {
          await getOfferedToCustomerTypeInfo({ categoryId })
          await getHasSpecialPrices({ categoryId })
        }
        if (cart.value) {
          setScenario(cart.value, 'userInQuarantine', false)
        }
      } catch (error) {
        console.error('Error loading checkout page:', error)
        // Let Nuxt error handler handle the error page display
        throw error
      }
    }, 'checkout')
    const goBack = () => {
      // https://jira.telmore.dk/browse/NLOS-2954
      const backUrl = window.sessionStorage.getItem('shopkoeb-back-url')
      // Only redirect if there's a backUrl set - don't redirect to /shop/ when MitID returns
      // If user came from MitID but there's no backUrl, they should stay on checkout page
      if (backUrl) {
        window.location.href = backUrl
        return
      }
      // If came from MitID but no backUrl, don't redirect - stay on checkout
      if (cameFromMitid.value) {
        return
      }
      window.history.back()
    }

    onMounted(() => {
      // listen for the browser back/forward button and trigger goBack function
      // Ensure the event listener is only added on the client side
      window.addEventListener('popstate', goBack);

      // Cleanup the event listener when the component is unmounted
      onBeforeUnmount(() => {
        window.removeEventListener('popstate', goBack);
      });
    });

    return {
      getCategoryForCartItemGroup,
      goBack,
      isLoading,
      isCartEmpty,
      cameFromMitid
    }
  },
  head () {
    const { isProdEnv } = useEnvironment()
    const externalScripts = {
      prod: 'https://checkout.dibspayment.eu/v1/checkout.js?v=1',
      test: 'https://test.checkout.dibspayment.eu/v1/checkout.js?v=1'
    }
    return {
      script: [
        {
          src: isProdEnv() ? externalScripts.prod : externalScripts.test,
          id: 'checkout',
          async: true,
          defer: true
        }
      ]
    }
  }
}
